// components/ErrorHeader.tsx
import React from 'react';
import './styles/ErrorHeader.css';

export const ErrorHeader = ({ Icon, title, description }) => (
  <div className="error-header">
    <h1 className="error-title">{title}</h1>
    <p className="error-description">{description}</p>
  </div>
);